export const AnalyticsEventNames = {
  PAGE_VIEW: 'page_view',
  LOGIN: 'login',
  SIGN_UP: 'sign_up',
  ACCOUNT_ACTIVATED: 'account_activated',
  ORGANIZATION_CREATED: 'organization_created',
  PROJECT_CREATED: 'project_created',
  CHANNEL_CREATED: 'channel_created',
  CLI_AUTHORIZED: 'cli_authorized',
  UPLOAD_GUIDE_OPENED: 'upload_guide_opened',
  COPY_CODE: 'copy_code',
  SELECT_CONTENT: 'select_content',
  MEMBER_INVITED: 'member_invited',
  INVITATION_RESPONDED: 'invitation_responded',
  PRODUCTION_CHANNEL_CHANGED: 'production_channel_changed',
  MANAGED_PUBLISHING_CHANGED: 'managed_publishing_changed',
  BUNDLE_ROLLOUT_UPDATED: 'bundle_rollout_updated',
  BUNDLE_ROLLBACK_COMPLETED: 'bundle_rollback_completed',
  BEGIN_CHECKOUT: 'begin_checkout',
  ACCESS_CODE_REDEEMED: 'access_code_redeemed',
  SUBSCRIPTION_CHANGED: 'subscription_changed',
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEventNames)[keyof typeof AnalyticsEventNames];

export type AnalyticsItem = {
  item_id: string;
  item_name: string;
  price?: number;
  quantity?: number;
};

export type AnalyticsEventParams = {
  [key: string]:
    | string
    | number
    | boolean
    | AnalyticsItem[]
    | null
    | undefined;
};
